import { QuoteItemTypeCodeName } from '@lio/rule-engine';
import { PanelTitles } from '@models/quotePanel';
import { PanelInstance } from '@store/Quote/Quote.types';

export const getPanelLabel = (pi: PanelInstance) => {
  const label = pi.panel.label ?? 'UNLABELED';
  const quoteItemCodeName = pi.quoteItem.quoteItemType.codeName;

  // Note: Not all Panel titles will be named consistently and some QuoteItems may have multiple panels, proceed with caution
  if (quoteItemCodeName === QuoteItemTypeCodeName.QuoteLocation && label === PanelTitles.Location) {
    const customLocationName = pi.quoteItem.attributeTypes.LocationName?.attribute?.value;
    const streetAddress = pi.quoteItem.attributeTypes.AddressStreet?.attribute?.value;
    const streetAddress2 = pi.quoteItem.attributeTypes.AddressStreet2?.attribute?.value;
    const addressLabel = `${streetAddress}${streetAddress2 ? `, ${streetAddress2}` : ''}`;
    return customLocationName ? `${label} - ${customLocationName}` : `${label} - ${addressLabel}`;
  }

  if (quoteItemCodeName === QuoteItemTypeCodeName.Jurisdiction) {
    const jurisdictionState = pi.quoteItem.attributeTypes.StateCode?.attribute?.value;
    return jurisdictionState ? `${label} - ${jurisdictionState}` : `${label}`;
  }

  if (quoteItemCodeName === QuoteItemTypeCodeName.LiabilityClass) {
    const liabilityRiskClassificationName = pi.quoteItem?.attributeTypes?.GLClassificationName?.attribute?.value;
    return liabilityRiskClassificationName !== 'Classification 1' && !!liabilityRiskClassificationName
      ? `${label} - ${liabilityRiskClassificationName}`
      : `${label}`;
  }

  if (quoteItemCodeName === QuoteItemTypeCodeName.PropertyRisk) {
    const propertyRiskClassificationLabel = pi.quoteItem?.attributeTypes?.CPPropertyLabel?.attribute?.value;
    return propertyRiskClassificationLabel ? `${label} - ${propertyRiskClassificationLabel}` : `${label}`;
  }

  return label;
};
